import {useCallback} from 'react';

import {KYC_IN_REVIEW_IDV_EVENTS} from '@/app/auth/events/KycInReviewIdvEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {IPlaidDataDefinition} from '@/services/segment/models/TrackingManagerEventModel';

export interface IAdIdsTrack {
  provider?: string;
  id?: string;
}

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewKycInReviewIdvPlaidShowWebview = useCallback(() => {
    trackEvent(
      KYC_IN_REVIEW_IDV_EVENTS.VIEW_KYC_IN_REVIEW_IDV_PLAID_SHOW_WEBVIEW,
      {
        project_tag: PROJECT_TAGS.ONBOARDING,
      },
    );
  }, [trackEvent]);

  const trackViewKycInReviewIdvPage = useCallback(() => {
    trackEvent(KYC_IN_REVIEW_IDV_EVENTS.VIEW_KYC_IN_REVIEW_IDV_PAGE, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackViewKycInReviewIdvPlaidError = useCallback(
    (code?: string, message?: string) => {
      trackEvent(
        KYC_IN_REVIEW_IDV_EVENTS.VIEW_KYC_IN_REVIEW_IDV_PLAID_ERROR,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
        },
        {
          code: code || '',
          message: message || '',
        },
      );
    },
    [trackEvent],
  );

  const trackSelectKycInReviewIdvPlaidExit = useCallback(() => {
    trackEvent(KYC_IN_REVIEW_IDV_EVENTS.SELECT_KYC_IN_REVIEW_IDV_PLAID_EXIT, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackViewKycInReviewIdvPlaidSuccess = useCallback(() => {
    trackEvent(KYC_IN_REVIEW_IDV_EVENTS.VIEW_KYC_IN_REVIEW_IDV_PLAID_SUCCESS, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackSelectKycInReviewIdvGoToVerification = useCallback(() => {
    trackEvent(
      KYC_IN_REVIEW_IDV_EVENTS.SELECT_KYC_IN_REVIEW_IDV_GO_TO_VERIFICATION,
      {
        project_tag: PROJECT_TAGS.ONBOARDING,
      },
    );
  }, [trackEvent]);

  const trackPlaidEvent = useCallback(
    (eventName: string, plaidEvent?: IPlaidDataDefinition) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        ...(plaidEvent && {
          Plaid: plaidEvent,
        }),
      });
    },
    [trackEvent],
  );

  return {
    trackViewKycInReviewIdvPlaidShowWebview,
    trackViewKycInReviewIdvPage,
    trackViewKycInReviewIdvPlaidError,
    trackSelectKycInReviewIdvPlaidExit,
    trackViewKycInReviewIdvPlaidSuccess,
    trackSelectKycInReviewIdvGoToVerification,
    trackPlaidEvent,
  };
};
